<template>
  <div class="order-page">
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <!-- <WelcomeCard /> -->
          <div class="col-xxl-12">
            <div class="row widget-grid">
              <OrderWelcomeCard />
              <!-- <OrderPurchaseSaleCard /> -->
              <div class="col-xl-4 col-sm-6 box-col-6">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="card widget-1 section-card summary-stat-card">
                      <div class="card-body">
                        <div class="widget-content">
                          <div class="widget-round secondary">
                            <div class="bg-round">
                              <svg class="svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#cart`
                                  "
                                ></use>
                              </svg>
                              <svg class="half-circle svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#halfcircle`
                                  "
                                ></use>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h4>{{ this.total_order }}</h4>
                            <span class="f-light"> คำสั่งซื้อ  </span>
                          </div>
                          <div>&nbsp;</div>
                        </div>
                      </div>
                    </div>
                    <div class="card widget-1 section-card summary-stat-card">
                      <div class="card-body">
                        <div class="widget-content">
                          <div class="widget-round primary">
                            <div class="bg-round">
                              <svg class="svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#income`
                                  "
                                ></use>
                              </svg>
                              <svg class="half-circle svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#halfcircle`
                                  "
                                ></use>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h4>{{ this.total_image }}</h4>
                            <span class="f-light"> ยอดขาย </span>
                          </div>
                          <div>&nbsp;</div>
                          <div>
                            <h4 v-if="this.total_image_all !== 0">
                              {{
                                Number(
                                  (this.total_image * 100) /
                                    this.total_image_all
                                ).toFixed(2)
                              }}
                              %
                            </h4>
                            <h4 v-else>0 %</h4>
                            <span class="f-light"> เปอร์เซ็นต์ยอดขาย </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-sm-6 box-col-6">
                <div class="row">
                  <div class="col-xl-12">
                    <div class="card widget-1 section-card summary-stat-card">
                      <div class="card-body">
                        <div class="widget-content">
                          <div class="widget-round success">
                            <div class="bg-round">
                              <svg class="svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#fill-gallery`
                                  "
                                ></use>
                              </svg>
                              <svg class="half-circle svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#halfcircle`
                                  "
                                ></use>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h4>{{ this.total_image_all }}</h4>
                            <span class="f-light"> รูปที่อัปโหลดเข้าระบบ </span>
                            <!-- <a :href="'/upload-images/'+this.$route.params.q" target="_blank">(รายชื่อรูปที่อัปโหลด)</a> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card widget-1 section-card summary-stat-card">
                      <div class="card-body">
                        <div class="widget-content">
                          <div class="widget-round success">
                            <div class="bg-round">
                              <svg class="svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#profit`
                                  "
                                ></use>
                              </svg>
                              <svg class="half-circle svg-fill">
                                <use
                                  :xlink:href="
                                    require('@/assets/svg/icon-sprite.svg') +
                                    `#halfcircle`
                                  "
                                ></use>
                              </svg>
                            </div>
                          </div>
                          <div>
                            <h4>{{ this.p_share }}</h4>
                            <span class="f-light">
                              ส่วนแบ่งช่างภาพ({{ this.photographer_share }}%)
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <AllCampaignsCard /> -->

      <div class="col-xl-12">
        <div class="card section-card">
          
          <div class="card-header">
            <div class="header-top action-header">
              <h5 class="m-0">รายการขาย</h5>
              <button
                  type="button"
                  @click.prevent="loadOrder()"
                  class="btn btn-primary action-btn"
                >
                  <vue-feather type="refresh-cw" size="18"> </vue-feather>
                  Refresh
                </button>
            </div>
          </div>
          <span v-if="this.loadding === 'N'">
          <div class="table-responsive" v-if="this.is_mhao === 'N'">
            <table class="table table-striped data-table">
              <thead>
                <tr>
                  <th scope="col" style="text-align: center">
                    <b>คำสั่งซื้อ</b>
                  </th>
                  <th style="text-align: center"><b>รูปที่ขายได้</b></th>
                  <th style="text-align: center"><b>ราคา</b></th>
                  <th style="text-align: left"><b>วันที่ชำระเงิน</b></th>
                  <th style="text-align: left"><b>ชื่อ</b></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="order in this.orders" :key="order">
                  <td scope="row" style="text-align: center">
                    <b>{{ order.confirm_key }}</b>
                  <br>
                    <p v-if="order.thumbnail_file_name !== 'hybrid_order'">(1/{{ order.order_image_length }})</p>
                    <p v-if="order.thumbnail_file_name === 'hybrid_order'">({{ Number(order.system_share)}}/{{ order.order_image_length }})</p>
                  </td>
                  <td scope="row" style="text-align: left">
                    <img :alt="order.original_file_name"
                      v-if="order.thumbnail_file_name !== 'hybrid_order'"
                      :src="
                        this.s3_url +'/'+
                        order.event_key +
                        '/thumbnail/' +
                        order.thumbnail_file_name
                      "
                      style="height: 200px; border: 3px solid #000000;"
                    />

                    <a v-if="order.thumbnail_file_name === 'hybrid_order'" :href="this.$route.params.q +
                              '/view/' +
                              order.confirm_key +
                              order.order_id" target="_blank" >
                    <img :alt="order.original_file_name"
                      src="../../assets/images/running/order-share.png"
                      style="height: 100px; border: 1px solid #000000;border-radius: 10px;" /></a>
                    
                    <!-- <img :alt="order.original_file_name"
                      v-if="order.order_id < 5000"
                      :src="order.thumbnail_file_name"
                      style="height: 200px; border: 3px solid #000000;"
                    /> -->
                  </td>
                  <td style="text-align: center">
                    {{ order.user_share }}
                  </td>
                  <td style="text-align: left">
                    {{ order.payment_date }}
                  </td>
                  <td style="text-align: left">
                    {{ order.original_file_name }}
                  </td>
                </tr>
              </tbody>

              <tbody v-if="this.total_image <= 0">
                <tr>
                  <td colspan="5">
                    <div class="d-flex justify-content-center">ไม่พบข้อมูล</div>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>&nbsp;</p>
            <div class="d-flex justify-content-center">
              <paginate
                v-if="this.total_image > this.init_page_size"
                v-model="page"
                :page-count="this.page_tab"
                :page-range="3"
                :margin-pages="2"
                :clickHandler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination pagination-sm'"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
            <span style="color: white;">
            sp0:{{ (((this.total_amt * this.system_share)/100)-this.total_image_all*0.055).toFixed(2) }}, 
            spAddV:{{ ((((this.total_amt * this.system_share)/100)-this.total_image_all*0.055)+(this.total_amt*7/100)).toFixed(2) }}, 
            sp1:{{ (((this.total_amt * this.system_share)/100)-this.total_image_all*0.1).toFixed(2) }}, 
            sv1:{{ (this.total_amt*7/100).toFixed(2) }}
            </span>

          </div>
          </span>
          <span v-if="this.loadding === 'Y'">
            <div class="d-flex justify-content-center" style="padding: 20px;" v-if="this.loadding === 'Y'" >
              <img style="align-items: center; width: 50px" src="../../assets/images/running_loading.svg"/>
            </div>
          </span>
          <div v-if="this.is_mhao !== 'N' && this.loadding === 'N'">
            <div class="d-flex justify-content-center">
              this page is not authorized
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<style scoped>
.order-page {
  background: radial-gradient(circle at top right, #f4f9ff 0%, #ffffff 45%);
  padding: 0.25rem 0 0.75rem;
}

.btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  color: #fff !important;
  opacity: 0.65;
  cursor: not-allowed !important;
}
.table-fit {
  width: 1px;
}

.btn-primary {
  background: linear-gradient(135deg, #33adf3 0%, #ab7dda 100%);
  border: none;
}

.section-card {
  border: 1px solid #e4edf7;
  border-radius: 0.9rem;
  box-shadow: 0 10px 24px rgba(32, 75, 140, 0.06);
}

.summary-stat-card {
  overflow: hidden;
}

.action-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.action-btn {
  border-radius: 999px;
  padding: 0.42rem 0.95rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.data-table thead th {
  border-bottom: 1px solid #dce7f4;
  background: #f8fbff;
  color: #24426b;
  font-weight: 700;
  font-size: 0.82rem;
}

.data-table tbody td {
  vertical-align: middle;
}

.loading-spinner {
  width: 72px;
  height: 72px;
  animation: loading-spin 0.85s linear infinite;
}

@keyframes loading-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {
  .action-btn {
    width: 100%;
    justify-content: center;
  }

  .loading-spinner {
    width: 60px;
    height: 60px;
  }
}

</style>
<script>
import orderDetail from "./orderDetail.vue";
import OrderWelcomeCard from "./orderWelcomeCard.vue";
import VuejsPaginateNext from "./../../components/Paginate.vue";
import axios from "axios";
export default {
  name: "order",
  components: {
    orderDetail,
    OrderWelcomeCard,
    paginate: VuejsPaginateNext,
  },
  setup() {},
  data() {
    return {
      orders: [],
      is_mhao: null,
      order_count: 0,
      page_tab: 0,
      loadding: "N",
      page: 1,
      init_page_size: 20,

      total_order: 0,
      total_amt: null,
      p_share: 0,
      total_image: 0,
      total_image_all: 0,
      photographer_share: 60,
      s3_url: process.env.VUE_APP_AWS_S3_URL,
      token: localStorage.getItem("jwt")
    };
  },
  async mounted() {
    //this.user = this.user_store.user.body;
    
    this.loadOrder();
  },
  methods: {
    async loadOrder(){
      this.total_order = 0;
      this.total_amt = 0;
      this.p_share = 0;
      this.total_image = 0;
      this.total_image_all = 0;
      this.photographer_share = 0;
      this.system_share = 0;
      this.loadding = "Y";
      try {
        const headers = {
         'Authorization': 'Bearer ' + localStorage.getItem("jwt")
      };
        const response_summery = await axios.get(
          "/v1/order/order-summery/" + this.$route.params.q,
          {
            headers
          }
        );
        if (response_summery.data.is_mhao !== "Y") {
          if (response_summery.data.body.total_order !== null) {
            
            this.total_order = response_summery.data.body.total_order;
            this.total_amt = response_summery.data.body.total_amt;
            this.p_share = response_summery.data.body.p_share;
            this.total_image = response_summery.data.body.total_image;
            this.total_image_all = response_summery.data.body.total_image_all;
            this.photographer_share = response_summery.data.body.photographer_share;
            this.system_share = response_summery.data.body.system_share;

            // set for detail pagination //
            this.order_count = this.total_order;
            this.page_tab = Math.round(
              this.total_image / this.init_page_size + 0.5
            );
            //----------------//

            let data = {
              page: 1,
              page_size: this.init_page_size,
              order_count: this.order_count,
              page_tab: this.page_tab,
            };
            this.orders = null
            const headers = {
                  'Authorization': 'Bearer ' + this.token
              };
            const response = await axios.post(
              "/v1/order/order-paid-pagination/" + this.$route.params.q,
              data,
              {
                headers
              }
            );
            //console.log("response"+JSON.stringify(response));
            if (response.data.status === "success") {
              this.orders = response.data.body;
              this.is_mhao = response.data.is_mhao;
              this.loadding = "N";
            } else {
              alert("Load order พบข้อผิดพลาด!");
            }
          }
        }
      } catch (error) {
        alert("พบข้อผิดพลาดกรุณาติดต่อผู้ดูแลระบบ", error);
        //this.$router.push({ path: "/auth/login" });
      }
    },
    async clickCallback(pageNum) {
      let data = {
        page: pageNum,
        page_size: this.init_page_size,
        order_count: this.order_count,
        page_tab: this.page_tab,
      };
      const headers = {
         'Authorization': 'Bearer ' + this.token
      };
      const response = await axios.post(
        "/v1/order/order-paid-pagination/" + this.$route.params.q,
        data,
        {
          headers
        }
      );
      this.orders = response.data.body;
    },
  },
};
</script>
